import { discountGroupConstants } from '../constants';
import { discountGroupService } from '../../services';

export const discountGroupActions = {
  discountGroupsList,
  addDiscountGroup,
  getDiscountGroup,
  updateDiscountGroup
}

/*
ACTION: DiscountGroups List
*/
function discountGroupsList(pageID, perPage, searchInput) {
  return dispatch => {
    dispatch(request());
    return discountGroupService.discountGroupsList(pageID, perPage, searchInput)
      .then(
        response => {
          dispatch(success(response.data.body.discounts, response.data.body.data.total));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: discountGroupConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: discountGroupConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: discountGroupConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add DiscountGroup
*/
function addDiscountGroup(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return discountGroupService.addDiscountGroup(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: discountGroupConstants.ADD_REQUEST } }
  function success(status) { return { type: discountGroupConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: discountGroupConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get DiscountGroup By ID
*/
function getDiscountGroup(discountGroupID) {
  return dispatch => {
    dispatch(request());
    return discountGroupService.getDiscountGroup(discountGroupID)
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: discountGroupConstants.GET_REQUEST } }
  function success(item) { return { type: discountGroupConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: discountGroupConstants.GET_FAILURE, error } }
}

/*
ACTION: Update DiscountGroup
*/
function updateDiscountGroup(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return discountGroupService.updateDiscountGroup(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: discountGroupConstants.UPDATE_REQUEST } }
  function success(status) { return { type: discountGroupConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: discountGroupConstants.UPDATE_FAILURE, error } }
}